module.exports = __webpack_public_path__ + "static/media/Milan_WelcomeKit_Chinese_digital_111119.4bf7029d.pdf";